import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import Image from '../../elements/Image';

import './style.scss';

function Testimonials(props) {
  const { companies } = props;

  // Maintain a variable of the currently selected slide, and slide height
  const [slide, setSlide] = useState(0);
  const [slideHeight, setSlideHeight] = useState(0);

  // Keeps track of when the user selects a slide
  const intervention = useRef(false);

  // Get the slide height on first render
  useEffect(() => {
    const slide = document.getElementsByClassName('slide')[0];
    setSlideHeight(slide ? slide.clientHeight : 300);
  }, []);

  // Setup an autoscroll until the user selects a slide
  setTimeout(() => {
    if (!intervention.current) {
      nextSlide();
    }
  }, 5000);

  // Used by autoscroll to go to the next slide
  function nextSlide() {
    if (slide == companies.length - 1) {
      setSlide(0);
    } else {
      setSlide(slide + 1);
    }
  }

  // Set negative margins on the first slide based on position
  // to scroll the companies.
  function getOffset(i) {
    let offset;
    if (i == 0) {
      offset = {
        marginTop: '-' + (slideHeight * slide).toString() + 'px',
      };
    } else {
      offset = {
        marginTop: '0',
      };
    }
    return offset;
  }

  // Highlight the selector of the active slide
  function setActive(i) {
    let background;
    if (i == slide) {
      background = {
        opacity: '1.0',
      };
    } else {
      background = {
        opacity: '0.3',
      };
    }
    return background;
  }

  // Onclick function for selecting a slide.
  // Mark that the user has intervened to pause the autoscroll.
  function setSelectedSlide(i) {
    intervention.current = true;
    setSlide(i);
  }

  return (
    <div className="testimonials-container">
      <div className="testimonials-wrapper">
        <div className="controller d-flex flex-column justify-content-center">
          {companies.map((testimonial, i) => {
            return (
              <div
                key={i}
                className="selector"
                value={i}
                onClick={() => setSelectedSlide(i)}
                style={setActive(i)}
              ></div>
            );
          })}
        </div>
        {companies.map((testimonial, i) => {
          return (
            <div
              key={i}
              className="slide d-flex flex-column justify-content-center"
              style={getOffset(i)}
            >
              <div className="logo">
                <Image
                  src={testimonial.image}
                  alt={testimonial.company + ' logo'}
                />
              </div>
              <h3 className="white-text">{testimonial.quote}</h3>
              <h5 className="white-text">{testimonial.name}</h5>
              <h6>{testimonial.position}</h6>
            </div>
          );
        })}
      </div>
    </div>
  );
}

Testimonials.propTypes = {
  companies: PropTypes.array.isRequired,
};

export default Testimonials;
